module.exports = __webpack_public_path__ + "img/hotel2.755f7055.png";